import { ChevronRight } from 'lucide-react';
import styled from 'styled-components';

import { ClienteProdutoListItem } from '../../../../../../types/cliente-produto';
import { formatPreco, simNao } from './format';
import { ProdutoStatusBadge } from './produto-status-badge';
import { ProdutoTipoBadge } from './produto-tipo-badge';

interface Props {
  items: ClienteProdutoListItem[];
  onOpen: (id: string) => void;
}

const List = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

const Item = styled.li`
  background: ${({ theme }) => theme.colors.bgSurface};
  border: 1px solid ${({ theme }) => theme.colors.border};
  border-radius: ${({ theme }) => theme.radius.lg};
`;

const Card = styled.button`
  width: 100%;
  text-align: left;
  display: grid;
  grid-template-columns: 1fr auto;
  gap: 8px;
  padding: 16px;
  background: transparent;
  border: none;
  border-radius: inherit;
  cursor: pointer;
  color: inherit;

  &:hover {
    background: ${({ theme }) => theme.colors.bgMuted};
  }
`;

const Top = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  grid-column: 1 / -1;
`;

const Info = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  line-height: 1.3;

  strong {
    font-weight: 600;
  }
  small {
    color: ${({ theme }) => theme.colors.textMuted};
    font-size: 12.5px;
  }
`;

const Meta = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 12.5px;
  color: ${({ theme }) => theme.colors.textMuted};
  margin-top: 4px;
`;

export const ProdutosCards = ({ items, onOpen }: Props) => (
  <List>
    {items.map((produto) => (
      <Item key={produto.id}>
        <Card
          onClick={() => onOpen(produto.id)}
          data-testid={`produto-card-${produto.id}`}
        >
          <Top>
            <Info>
              <strong>{produto.nome || '—'}</strong>
              {produto.categoriaDescricao && (
                <small>{produto.categoriaDescricao}</small>
              )}
            </Info>
            <ProdutoStatusBadge ativo={produto.ativo} />
          </Top>
          <Info>
            <strong>{formatPreco(produto.preco, produto.moedaSigla)}</strong>
            <small>Recorrente: {simNao(produto.recorrencia)}</small>
          </Info>
          <Meta>
            <ProdutoTipoBadge
              tipo={produto.tipo}
              descricao={produto.tipoDescricao}
            />
            <ChevronRight size={16} />
          </Meta>
        </Card>
      </Item>
    ))}
  </List>
);
